export function normalizeHandleForDisplay({ handle, type, }) {
    if (type === 'TWITTER' || type === 'INSTAGRAM') {
        if (!handle.startsWith('@')) {
            return `@${handle}`;
        }
    }
    return handle;
}
export function normalizeUsernameInput(s) {
    const matched = s.match(/^@?([a-zA-Z0-9_.]{0,30})$/);
    if (!matched)
        return null;
    return `@${matched[1].toLowerCase()}`;
}
export function extractDomainFromInput(inputValue) {
    try {
        let raw = inputValue.trim();
        if (!raw.startsWith('http://') && !raw.startsWith('https://')) {
            raw = `https://${raw}`;
        }
        const u = new URL(raw);
        if (!u.hostname.includes('.'))
            return null;
        const matches = u.href.match(/^https?:\/\/([^/]+)/i);
        if (!matches)
            return null;
        return matches[1];
    }
    catch {
        return null;
    }
}
